var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo-title"},[_c('span',{on:{"click":_vm.toPc}},[_c('svg-icon',{attrs:{"class-name":"logo","icon-class":"logo"}})],1),_vm._v(" "),_c('div',{staticClass:"title",on:{"click":_vm.routeToHome}},[_vm._v("创作中心")])])
}
var staticRenderFns = []

export { render, staticRenderFns }